import './settings.scss';

import { PERMISSIONS } from '@basqet-dashboard/common/config';
import { useHasPermission } from '@basqet-dashboard/common/hooks';
import { FLAGS } from '@basqet-dashboard/common/utils';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import React from 'react';
import { useParams } from 'react-router';
import { Redirect } from 'react-router-dom';

import { BusinessSettings, KycSettings, SecuritySettings, SettlementSettings } from './tabs';
import { BeneficiariesSettingsPage } from './tabs/beneficiaries/beneficiaries';
import TeamsPage from './tabs/teams/teams';

function Settings() {
  const { tab } = useParams();
  const onboardingEnabled = useFeatureFlagEnabled(FLAGS.ONBOARDING_V2);

  const defaultTab = 'security'; // Tab everyone can access
  const hasPermission = useHasPermission();

  if (tab === 'kyc' && onboardingEnabled !== false) {
    return <Redirect to="/onboard" />;
  }

  const canViewTab = tab && hasPermission(tabPermissions[tab]);

  // Determine which tab to show
  const selectedTab = canViewTab ? tab : defaultTab;

  const TabComponent = tabs[selectedTab];

  return <div className="settings">{TabComponent}</div>;
}

const tabPermissions = {
  kyc: PERMISSIONS.SETTINGS_MANAGE,
  business: PERMISSIONS.SETTINGS_MANAGE,
  security: PERMISSIONS.ANY,
  settlement: PERMISSIONS.SETTLEMENTS_VIEW,
  beneficiary: PERMISSIONS.BENEFICIARIES_VIEW,
  teams: PERMISSIONS.ANY // Anyone can view teams, not anyone can manage teams
};

const tabs = {
  kyc: <KycSettings />,
  business: <BusinessSettings key="business" />,
  security: <SecuritySettings key="security" />,
  settlement: <SettlementSettings key="settlements" />,
  beneficiary: <BeneficiariesSettingsPage key="beneficiaries" />,
  teams: <TeamsPage key="teams" />
};
export { Settings };
